export default "__VITE_ASSET__D1Q2Vr0n__"